import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

const AlertMessage = ({ variant, children }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Alert severity={variant}>{children}</Alert>
        </div>
    );

}

AlertMessage.defaultProps = {
    variant: 'info',
}

export default AlertMessage